import { render, staticRenderFns } from "./Exhibitions.vue?vue&type=template&id=376a7c24&"
import script from "./Exhibitions.vue?vue&type=script&lang=js&"
export * from "./Exhibitions.vue?vue&type=script&lang=js&"
import style0 from "./Exhibitions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports